export default function InitFAQ() {

    // Initially hide all FAQ answers
    jQuery(".schema-faq-answer").hide();

    jQuery(".schema-faq-question").click(function () {
        const answer = jQuery(this).next('.schema-faq-answer');
        const isCurrentlyOpen = answer.is(':visible');
        
        // Close all other FAQ answers and remove active class
        jQuery('.schema-faq-answer').slideUp(300);
        jQuery('.schema-faq-question').removeClass('active');
        
        // If this one wasn't open, open it
        if (!isCurrentlyOpen) {
            answer.slideDown(300);
            jQuery(this).addClass('active');
        }
    });

    jQuery(window).scroll(function () {
        var scrollToTop = jQuery('.scroll-to-top');
        if (500 < jQuery(document).scrollTop()) {
            scrollToTop.css('opacity', '1');
        } else {
            scrollToTop.css('opacity', '0');
        }
    });

}
